export const EscalatorOff = ({ width = '25', height = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#868C98"
      d="M7.08 5.71a1.71 1.71 0 0 1 2.922-1.21 1.71 1.71 0 1 1-2.42 2.42 1.7 1.7 0 0 1-.502-1.21m1.164 13.34H6.396a2.396 2.396 0 0 1-1.694-4.087 2.4 2.4 0 0 1 1.694-.701h.342v-4.105a2.052 2.052 0 0 1 3.505-1.451c.386.385.602.907.602 1.451v.684l1.41-1.585a3.42 3.42 0 0 1 2.56-1.151h1.848a2.396 2.396 0 0 1 2.396 2.394 2.394 2.394 0 0 1-2.396 2.394h-1.095a.7.7 0 0 0-.512.23l-4.25 4.78a3.42 3.42 0 0 1-2.562 1.147m-.137-5.13 1.369-1.54v-2.223a.684.684 0 0 0-1.37 0zm-1.711 3.762h1.848a2.05 2.05 0 0 0 1.534-.689l4.251-4.779a2.06 2.06 0 0 1 1.539-.689h1.095a1.027 1.027 0 1 0 0-2.052h-1.848a2.06 2.06 0 0 0-1.535.689L9.03 14.94a2.05 2.05 0 0 1-1.54.689H6.397a1.027 1.027 0 1 0 0 2.052"
    />
    <path
      stroke="#868C98"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m18.25 16.75-1.5 1.5m0-1.5 1.5 1.5M20 17.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
    />
  </svg>
);
